import { useNavigate } from "@tanstack/react-router";
import { FC, useCallback, useEffect, useRef, useState } from "react";
import { updateLogoutTime } from "~/services/auth.services";
import { SubmitButton as Button } from "~/components/form/submit-button";
import { useAuth } from "~/hooks/TGEPE/use-auth";
import RolesModal from "~/components/pages/login/role-selection";

interface NavbarProps {
  userName: string | null;
}
const Navbar: FC<NavbarProps> = ({ userName }) => {
  const { roles } = useAuth();
  const [showRolesModal, setShowRolesModal] = useState(false);

  const [showDropdown, setShowDropdown] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);
  const handleClickOutside = useCallback((event: MouseEvent) => {
    if (
      dropdownRef.current &&
      !dropdownRef.current.contains(event.target as Node)
    ) {
      setShowDropdown(false);
    }
  }, []);
  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [handleClickOutside]);

  const navigate = useNavigate();
  const userRole = localStorage.getItem("userRole");
  const closeModal = () => {
    setShowRolesModal(false);
  };

  const handleIconClick = () => {
    setShowDropdown(!showDropdown);
  };

  const handleLogout = async () => {
    const { status, data: response } = await updateLogoutTime();
    if ((response as any).data == "success") {
      console.log("logout time updated successfully", status);
    }
    localStorage.clear();
    sessionStorage.clear();
    navigate({ to: "/" });
  };

  return (
    <nav className="px-2 py-1 bg-white flex items-center justify-between shadow-[0_0px_2px_0] shadow-black z-50 w-full">
      <a className="cursor-pointer">
        <img
          src="/images/malkomAI_black.png"
          className="max-w-full max-h-full"
          width={100}
          height={100}
          alt=""
        ></img>
      </a>

      <div ref={dropdownRef} className="relative flex ">
        <div className="inline-block">
          <img
            src="/images/profileIcon.png"
            alt="Profile"
            width={30}
            height={30}
            onClick={handleIconClick}
          ></img>
        </div>
        {showDropdown && (
          <div className="absolute top-full right-0 z-10 bg-white border border-gray-300 py-2 px-4 w-[275px]">
            <div className="flex flex-col text-center ">
              {userName && (
                <span className="mr-4 font-bold text-orange-500">
                  Hi, {userName}
                </span>
              )}
              <span className="text-sm text-gray-500"> {userRole}</span>
            </div>
            <Button
              className="mt-2 h-5 w-[100%] flex gap-2"
              variant={"secondary"}
              onClick={() => setShowRolesModal(true)}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="15"
                height="15"
                viewBox="0 0 25 25"
                fill="none"
                stroke="#F56314"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path d="M17 2.1l4 4-4 4" />
                <path d="M3 12.2v-2a4 4 0 0 1 4-4h12.8M7 21.9l-4-4 4-4" />
                <path d="M21 11.8v2a4 4 0 0 1-4 4H4.2" />
              </svg>{" "}
              Change Role
            </Button>

            <Button
              onClick={handleLogout}
              className="mt-2 h-5 w-[100%] flex gap-2"
              variant={"secondary"}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="15"
                height="15"
                viewBox="0 0 25 25"
                fill="none"
                stroke="#F56314"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path d="M16 17l5-5-5-5M19.8 12H9M13 22a10 10 0 1 1 0-20" />
              </svg>
              Logout
            </Button>
          </div>
        )}
      </div>

      {showRolesModal && (
        <RolesModal onClose={closeModal} roles={roles as any} />
      )}
    </nav>
  );
};

export default Navbar;
